import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import addMonths from 'date-fns/addMonths';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import AccessRightFormModal from '../../accessRights/components/AccessRightFormModal';
import createVehicleService from '../../vehicles/services/createVehicleService';
import createAccessRightService from '../../accessRights/services/createAccessRightService';

let now;
const getNowOnce = () => {
  if (!now) {
    now = new Date();
    now.setHours(now.getHours(), 0, 0, 0);
  }
  return now;
};

let future;
const getFutureOnce = () => {
  if (!future) {
    future = addMonths(getNowOnce(), 6);
  }
  return future;
};

class NewRequestModal extends PureComponent {
  handleSubmit = body => {
    const { dispatchCreateAccessRightPost, dispatchCreateVehiclePost, returnRoute, t } = this.props;
    if (body.licensePlate) {
      dispatchCreateVehiclePost(body, {
        callback: createdVehicle =>
          dispatchCreateAccessRightPost(
            {
              ...body,
              vehicleId: createdVehicle.id,
              licensePlate: undefined,
            },
            returnRoute
          ),
        toaster: {
          onErrorMessage: t('vehicleCreateErr'),
        },
        redirectRoute: returnRoute,
      });
    } else {
      dispatchCreateAccessRightPost(body, returnRoute);
    }
  };
  render() {
    const {
      open,
      createAccessRightFetch,
      licensePlate,
      returnRoute,
      createVehicleFetch,
      organisationId,
      t,
    } = this.props;
    if (!open) {
      return null;
    }
    return (
      <AccessRightFormModal
        header={`${
          licensePlate ? t('newAccessRightForVehicle', { licensePlate }) : t('newAccessRight')
        }`}
        onSubmit={this.handleSubmit}
        submitProcessing={!!createAccessRightFetch.pending || !!createVehicleFetch.pending}
        licensePlate={licensePlate}
        returnRoute={returnRoute}
        data={{
          validFrom: getNowOnce(),
          validUntil: getFutureOnce(),
          stateId: 1,
          owner: { ownedById: organisationId },
        }}
      />
    );
  }
}

NewRequestModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchCreateAccessRightPost: PropTypes.func.isRequired,
  dispatchCreateVehiclePost: PropTypes.func.isRequired,
  createAccessRightFetch: PropTypes.object.isRequired,
  createVehicleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  licensePlate: PropTypes.string,
  returnRoute: PropTypes.string,
  organisationId: PropTypes.string.isRequired,
};

NewRequestModal.defaultProps = {
  licensePlate: undefined,
  returnRoute: '/accessrights',
};

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});

export default compose(
  connect(mapStateToProps),
  withTranslation(),
  createAccessRightService,
  createVehicleService
)(NewRequestModal);
